import { createSelector } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Filter } from 'src/types';
import { getFilterCount, getFilterOptionCount, getFilterOptionsForFilter } from './selectorHelpers';

export interface FilterWithFilterOptionsCount extends Filter {
  selectedFilterOptionsCount: number;
}

export const selectSelectedFilterOptions = (state: ReduxApplicationState) =>
  state.filter.collections.selectedFilterOptions;

export const selectFilters = (state: ReduxApplicationState) => state.filter.collections.filters;

const selectFilter = (_state: ReduxApplicationState, filter?: Filter) => filter;

export const selectFiltersWithFilterOptionsCount = createSelector(
  [selectSelectedFilterOptions, selectFilters],
  (selectedFilterOptions, filters): FilterWithFilterOptionsCount[] =>
    filters.map((filter) => {
      const filterOptionsForFilter = getFilterOptionsForFilter(filter, selectedFilterOptions);
      const selectedFilterOptionsCount = filterOptionsForFilter.reduce(
        (count, option) => (count += getFilterOptionCount(option)),
        0,
      );

      return {
        ...filter,
        selectedFilterOptionsCount,
      };
    }),
);

export const selectFilterWithFilterOptionsCount = createSelector(
  [selectFiltersWithFilterOptionsCount, selectFilter],
  (selectedFiltersWithFilterOptionsCount, filter) =>
    selectedFiltersWithFilterOptionsCount.find((flt) => flt.uid === filter?.uid),
);

export const selectTotalSelectedFilterOptionsCount = createSelector(
  [selectSelectedFilterOptions],
  (selectedFilterOptions) =>
    selectedFilterOptions.reduce((count, option) => (count += getFilterOptionCount(option)), 0),
);

export const selectTotalFiltersAppliedCount = createSelector(
  [selectSelectedFilterOptions],
  (selectedFilterOptions) =>
    selectedFilterOptions.reduce((count, option) => (count += getFilterCount(option)), 0),
);
